import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from '@/context/AuthContext';
import { PushNotificationsProvider } from '@/context/PushNotificationsContext';
import { NotificationProvider } from '@/context/NotificationContext';
import { ToastProvider } from '@/context/ToastContext';
import { SavedVocabularyProvider } from '@/context/SavedVocabularyContext';
import { AppErrorBoundary } from '@/components/organisms/AppErrorBoundary';
import { ensureServiceWorker } from '@/services/push/registerServiceWorker';
import { initNativeApp } from '@/platform/initNativeApp';
import { initAnalytics } from '@/platform/analytics';
import { isNative } from '@/platform/platform';
import App from './App';
import './styles/main.scss';

// Inicialización nativa (Capacitor): status bar + splash. No-op en web.
void initNativeApp();

// Analytics (GA4): stream web (gtag) o app (SDK nativo) según plataforma.
initAnalytics();

// Registra el Service Worker cuanto antes para que las push (y
// `serviceWorker.ready`) funcionen en cualquier dispositivo desde el primer uso.
// En la app nativa no: ahí el push es FCM/APNs y los assets son locales.
if (!isNative() && 'serviceWorker' in navigator) {
  void ensureServiceWorker().catch((err) => console.error('SW registration failed:', err));
}

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <AuthProvider>
        <PushNotificationsProvider>
          <NotificationProvider>
            <SavedVocabularyProvider>
              <ToastProvider>
                <App />
              </ToastProvider>
            </SavedVocabularyProvider>
          </NotificationProvider>
        </PushNotificationsProvider>
      </AuthProvider>
    </AppErrorBoundary>
  </React.StrictMode>
);
